import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import filmBlacklist from './filmBlacklist';
import cinemaBlacklist from './cinemaBlacklist';
import hmSetting from '@/views/manageCenter/components/hmSetting.vue';
import drfSmgSetting from '@/views/manageCenter/components/drfSmgSetting.vue';
import drfSmgCompanyCustomer from '@/views/manageCenter/components/drfSmgCompanyCustomer.vue';
import woermaCouponCustomer from '@/views/manageCenter/components/woermaCouponCustomer.vue';
import CakeStoreBlacklistDrawer from '@/views/manageCenter/components/cakeStoreBlacklistDrawer.vue';
import notTicketPhoneBlacklist from '@/views/cardSystem/customer/components/notTicketPhoneBlacklist.vue';
export default {
  name: '',
  components: {
    filmBlacklist: filmBlacklist,
    cinemaBlacklist: cinemaBlacklist,
    hmSetting: hmSetting,
    drfSmgSetting: drfSmgSetting,
    drfSmgCompanyCustomer: drfSmgCompanyCustomer,
    woermaCouponCustomer: woermaCouponCustomer,
    CakeStoreBlacklistDrawer: CakeStoreBlacklistDrawer,
    notTicketPhoneBlacklist: notTicketPhoneBlacklist
  },
  props: {
    marketSet: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    movieList: {
      type: Object,
      default: function _default() {
        return {
          movie: '',
          cinema: ''
        };
      }
    },
    id: {
      type: Number,
      default: ''
    },
    accountId: {
      type: String,
      default: ''
    },
    module: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      cakeStoreSxd_tabName: 'cakeStoreSxd_rate',
      // 蛋糕自由兑tab
      showChild: false,
      yonghuiBlackListOptions: [{
        value: '默认规则',
        label: '默认规则'
      }, {
        value: '个性化规则',
        label: '个性化规则'
      }],
      controlList: [{
        name: '默认规则',
        id: '0'
      }, {
        name: '个性化',
        id: '1'
      }]
    };
  },
  computed: {
    yonghuiBlackListValue: function yonghuiBlackListValue() {
      var black = this.marketSet && this.marketSet.cake_store_sxd_black_category;
      if (!black) return '';
      return black.blacklist_rule_type == 0 ? '默认规则' : '个性化规则';
    },
    yonghuiBlackListInfo: function yonghuiBlackListInfo() {
      var black = this.marketSet && this.marketSet.cake_store_sxd_black_category;
      if (!black) return '';
      var isDefault = black.blacklist_rule_type == 0;
      var category = isDefault ? black.small_category_code_channel : black.small_category_code;
      return category > 0 ? "(\u5C4F\u853D\u672B\u7EA7\u5206\u7C7B".concat(category, "\u4E2A)") : '';
    },
    brandAction: function brandAction() {
      var _this$marketSet;
      return (_this$marketSet = this.marketSet) === null || _this$marketSet === void 0 ? void 0 : _this$marketSet.cake_store_zyd_action;
    },
    brandTotal: function brandTotal() {
      var _this$marketSet2, _this$marketSet2$cake;
      return ((_this$marketSet2 = this.marketSet) === null || _this$marketSet2 === void 0 ? void 0 : (_this$marketSet2$cake = _this$marketSet2.cake_store_zyd_black_brand) === null || _this$marketSet2$cake === void 0 ? void 0 : _this$marketSet2$cake.length) || 0;
    },
    brandList: function brandList() {
      var _this$marketSet3;
      var list = (_this$marketSet3 = this.marketSet) === null || _this$marketSet3 === void 0 ? void 0 : _this$marketSet3.cake_store_zyd_black_brand;
      return Array.isArray(list) ? list.join('、') : '';
    },
    // 不出票手机号黑名单数量（接口返回可能为字符串，转数字；缺失时回退 0）
    blackMobilesCount: function blackMobilesCount() {
      var _this$marketSet4;
      return Number((_this$marketSet4 = this.marketSet) === null || _this$marketSet4 === void 0 ? void 0 : _this$marketSet4.black_mobiles_count) || 0;
    },
    WoermaCoupon: function WoermaCoupon() {
      var _data$woerma_default, _data$woerma_default2, _data$woerma_default3;
      var data = this.marketSet || {};
      return {
        accountConfig: {
          // 客户配置(当前客户使用的配置)
          woerma_coupon_type_control: data.woerma_coupon_type_control != null ? String(data.woerma_coupon_type_control) : '',
          coupon_type: data.woerma_coupon_type || '',
          woerma_coupon_description_control: data.woerma_coupon_description_control != null ? String(data.woerma_coupon_description_control) : '',
          coupon_description: data.woerma_coupon_description || ''
        },
        channelConfig: {
          // 渠道配置(默认规则)
          coupon_type: (data === null || data === void 0 ? void 0 : (_data$woerma_default = data.woerma_default) === null || _data$woerma_default === void 0 ? void 0 : _data$woerma_default.coupon_type) || '',
          coupon_description: (data === null || data === void 0 ? void 0 : (_data$woerma_default2 = data.woerma_default) === null || _data$woerma_default2 === void 0 ? void 0 : _data$woerma_default2.coupon_description) || ''
        },
        couponTypeOptions: (data === null || data === void 0 ? void 0 : (_data$woerma_default3 = data.woerma_default) === null || _data$woerma_default3 === void 0 ? void 0 : _data$woerma_default3.types) || []
      };
    },
    // 演出商品分类限制 - 规则类型
    yanchuClassifyType: function yanchuClassifyType() {
      var blacklist = this.marketSet.yanchu_classify_blacklist || {
        type: 0,
        channel: [],
        list: []
      };
      return blacklist.type;
    },
    // 演出商品分类限制 - 屏蔽商品分类label
    yanchuBlacklistLabel: function yanchuBlacklistLabel() {
      var blacklist = this.marketSet.yanchu_classify_blacklist || {
        type: 0,
        channel: [],
        list: []
      };
      var count = 0;
      if (blacklist.type === 0) {
        count = (blacklist.channel || []).length;
      } else {
        count = (blacklist.list || []).filter(function (c) {
          return c.check;
        }).length;
      }
      return count > 0 ? "\u5C4F\u853D\u5546\u54C1\u5206\u7C7B\uFF08".concat(count, "\u4E2A\uFF09\uFF1A") : '';
    },
    // 演出商品分类限制 - 分类名称列表
    yanchuBlacklistNames: function yanchuBlacklistNames() {
      var blacklist = this.marketSet.yanchu_classify_blacklist || {
        type: 0,
        channel: [],
        list: []
      };
      if (blacklist.type === 0) {
        return (blacklist.channel || []).join('、');
      } else {
        return (blacklist.list || []).filter(function (c) {
          return c.check;
        }).map(function (c) {
          return c.name;
        }).join('、');
      }
    }
  },
  methods: {
    setFilmBlackList: function setFilmBlackList() {
      this.$refs.filmBlack.isShow = true;
      this.$refs.filmBlack.searchBrand.customer_id = this.id;
      this.$refs.filmBlack.searchBrand.customer_account_id = this.accountId;
      this.$refs.filmBlack.getFilmList();
    },
    setCinemaBlackList: function setCinemaBlackList() {
      this.$refs.cinemaBlack.isShow = true;
      this.$refs.cinemaBlack.query.customer_id = this.id;
      this.$refs.cinemaBlack.query.customer_account_id = this.accountId;
      this.$refs.cinemaBlack.openWhiteCity();
      this.$refs.cinemaBlack.openWhiteCinema();
    },
    // 不出票手机号黑名单（只读查看）：打开弹窗后由子组件自行拉取列表
    setNotTicketPhoneBlacklist: function setNotTicketPhoneBlacklist() {
      this.$refs.notTicketPhoneBlack.isShow = true;
      this.$refs.notTicketPhoneBlack.getList();
    },
    // 打开永辉超市商品分类黑名单抜屉
    openBlacklistDrawer: function openBlacklistDrawer() {
      var drawer = this.$refs.cakeStoreBlacklistDrawer;
      drawer.item = {
        type: 'cake_store_sxd'
      };
      drawer.customerId = this.id;
      drawer.customerAccountId = this.accountId;
      drawer.visible = true;
      drawer.isEdit = false;
      drawer.loadCategoryList();
    }
  }
};